/**
 * 导出列映射：headerType / dynamicConfig 只认模板显式配置。
 * 未配置的「商品轮播图N」等列保持固定值空单元格，禁止按表头名推断结果图。
 */

export function resolveExportHeaderType(explicitHeaderType, hasDynamicConfig) {
  if (explicitHeaderType) return explicitHeaderType;
  if (hasDynamicConfig) return '动态值';
  return '固定值';
}

/** 空单元格且无显式动态配置时，不得按表头名写入结果图 */
export function shouldInferImageConfigForEmptyCell(cellText, hasExplicitDynamicConfig) {
  const str = String(cellText || '').trim();
  if (str) return true;
  return Boolean(hasExplicitDynamicConfig);
}
